import { render, staticRenderFns } from "./LaunchTab.vue?vue&type=template&id=23ee77c4"
import script from "./LaunchTab.vue?vue&type=script&lang=js"
export * from "./LaunchTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports